import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { CtcQueryOverrides } from 'src/api/queries/ctc/ctcSnapshotOptions';

/** @registry Previous/next CTC job numbers under the active division filter. */
export function useCtcNavigation(
  jobNumber: string | null | undefined,
  divisions: readonly string[],
  overrides?: CtcQueryOverrides,
) {
  return useQuery({
    queryKey: queryKeys.ctc.navigation(jobNumber ?? '', divisions),
    queryFn: ({ signal }) =>
      ctcApiClient.nextCTC(
        jobNumber!,
        { divisions: [...divisions] },
        toCancelToken(signal),
      ),
    enabled: !!jobNumber,
    staleTime: 0,
    ...overrides,
    meta: { errorContext: 'CTC navigation' },
  });
}
